import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ContainerLinesImportResult, PurchaseShipmentService } from '../../../_services/purchase-shipment.service';
import { AlertService } from '../../../_services/alert.service';

export interface ContainerLinesImportPreviewData {
  fileName: string;
  rows: any[];
  result: ContainerLinesImportResult;
}

// Every change a Containers-view import would make, field by field, before
// anything is saved. Closes with true once applied.
@Component({
    selector: 'app-container-lines-import-preview',
    imports: [CommonModule, MatDialogContent, MatIconModule, MatProgressSpinnerModule],
    templateUrl: './container-lines-import-preview.component.html'
})
export class ContainerLinesImportPreviewComponent {
  readonly dialogRef = inject(MatDialogRef<ContainerLinesImportPreviewComponent, boolean>);
  readonly data = inject<ContainerLinesImportPreviewData>(MAT_DIALOG_DATA);
  private shipmentService = inject(PurchaseShipmentService);
  private alertService = inject(AlertService);
  applying = false;

  readonly levels: { key: 'shipment' | 'container' | 'line'; label: string; icon: string }[] = [
    { key: 'shipment', label: 'Shipments', icon: 'directions_boat' },
    { key: 'container', label: 'Containers', icon: 'view_in_ar' },
    { key: 'line', label: 'Lines', icon: 'list_alt' },
  ];

  changesAt(level: string) {
    return this.data.result.changes.filter((c) => c.level === level);
  }

  apply(): void {
    if (this.data.result.errors.length || !this.data.result.changes.length || this.applying) return;
    this.applying = true;
    this.shipmentService.importContainerLines({ dryRun: false, rows: this.data.rows }).subscribe({
      next: (r) => {
        this.applying = false;
        if (!r.applied) {
          this.data.result = r;
          this.alertService.alert('Something changed since the check - see the errors', 'error');
          return;
        }
        this.alertService.alert(`${r.changes.length} change${r.changes.length === 1 ? '' : 's'} saved`, 'success');
        this.dialogRef.close(true);
      },
      error: (error) => {
        this.applying = false;
        this.alertService.alert(error?.error?.message || 'Import failed', 'error');
      },
    });
  }
}
